export const colors = {
  white: "#FFFFFF",
  darkWhite: "#d8d8d8",
  black: "#000000",
  lightBlack: "#282827",
  yellow: "#ffd400",
  bodyMain: "#131313",
  gray: "#2f2f2f",
  cardBg: "#2E2E2E",
  lightGray: "#636363",
  lightGreen: "#47CF8E",
  textMain: "#adadad",
  actualCardBg: "#2f2f2f",
  SelectBg: "#1e1e1e",
  datePickerBg: "#2f2f2f",
  brown: "#828282",
  redPink: "#ff004d",
  inputBg: "#404040",
  pink: "#fc3e78",
  datePickerYellow: "#ffd401",
  datePickerYellowFaded: "#D5B309",
  green: "#04BB0A",
  greenSuccess: "#00A953",
  darkBrow: "#f5b858",
  darkGray: "#1d1d1d",
  lightGreenVerify: "#99deb2",
  orangeRed: "#FF2600",
  lightRed: "#DB7092",
  redError: "#EF3D3A",
  datepickerText: "#2f2f2f",
  datePickerLine: "#979797",
  disabledGrey: "#808080",
  secondaryColor: "#f2f2f2",
  paleBlue: "#F8F9FF",

  baseSales: "#0d0c0c",
  baseSalesBorder: "#0d0c0c",
  priceSales: "#b9b9b9",
  priceSalesBorder: "#0d0c0c",
  controlSales: "#6f6f6f",
  controlSalesBorder: "#0d0c0c",
  brandSales: "rgba(93, 182, 245, 0.8)",
  brandSalesBorder: "rgba(93, 182, 245, 1)",
  mediaSales: "rgba(240, 160, 75, 0.8)",
  mediaSalesBorder: "#f0a04b",
  sharedMarketingSales: "rgba(249, 119, 137, 0.8)",
  sharedMarketingSalesBorder: "#f97789",
  brandMarketingSales: "rgba(93, 182, 245, 0.8)",
  brandMarketingSalesBorder: "#5db6f5",
  categoryMarketingSales: "rgba(240, 160, 75, 0.8)",
  categoryMarketingSalesBorder: "#f0a04b",

  marketingSales: "rgba(240, 160, 75, 0.8)",
  marketingBorder: "#f0a04b",
  breakdownExplorerBar: "rgba(13, 12, 12, 0.4)",
  breakdownExplorerBarDark: "rgba(13, 12, 12, 0.25)",
  labelGray: "#afaeae",

  tableTdGray: "rgba(151, 151, 151, 0.4)",
  sampleSize: "rgba(13, 12, 12, 0.5)",
  underCircleBorder: "#f7a600",
  underCircle: "rgba(247,166, 0, 0.4)",
  balancedCircleBorder: "#7ceb12",
  balancedCircle: "rgba(124,235, 18, 0.4)",
  overCircleBorder: "#ff635b",
  overCircle: "rgba(255,99,91, 0.4)",
  NACircle: "rgba( 13, 12 ,12, 0.5)",
  NACircleBorder: "#0d0c0c",
  curveGrey: "#c9c7c7",
  wellInvestedLine: "#20e9ab",
  overInvestedLine: "#fc3e78",
  underInvestedLine: "#f7a600",
  echartsDisableGrey: "#cccccc",

  environmentPositiveColor: "rgba(71, 207, 142, 0.8)",
  environmentNegativeColor: "rgba(252, 62, 120, 0.8)",
  environmentNeutralColor: "rgba(252, 186, 3, 0.8)",
  environmentPositiveColorBorder: "#47cf8e",
  environmentNegativeColorBorder: "#fc3e78",
  enviornmentNeutralColorBorder: "#fcba03",

  collapseBackground: "#272727",
  grey: "grey",

  circleGreenBorder: "#7ceb12",
  circleGreen: "rgba(124,235, 18, 0.4)",
  circleOrangeBorder: "#f7a600",
  circleOrange: "rgba(247,166, 0, 0.4)",
  circlePinkBorder: "#ff635b",
  circlePink: "rgba(255,99,91, 0.4)",

  totalValueGreen: "#4eb473",
  totalValueRed: "#fc2f5c",

  revenuePurple: "#795ABA",
};
